import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupByName',
})
export class GroupByName implements PipeTransform {
  transform(value, args: string[]): any {
    const groups = {};
    if (value != null)
      if (value.length > 0) {
        value.forEach(function (o) {
          const groupName = o.GroupName;
          const tournamentName = o.TournamentName;
          groups[groupName] = groups[groupName] ? groups[groupName] : { GroupName: groupName, TournamentName: tournamentName, eEvents: [] };
          groups[groupName].eEvents.push(o);
        });
      }
    return Object.keys(groups).map(function (key) {
      return groups[key];
    });
  }
}
